import {sdkApi} from './sdk.fetch';
import useSWR from 'swr';
import {DownloadRequest, SdkRes} from './sdk.types';

export const createKey = (request?: DownloadRequest): string => {
    if (!request) return '';
    return JSON.stringify(request);
};

export const useSdk = (): {data?: SdkRes; isLoading: boolean; error?: string} => {
    const {data, error} = useSWR('sdk', sdkApi.getSdk, {
        errorRetryCount: 1,
        revalidateOnFocus: false
    });

    const responseError = data?.error;
    return {
        data,
        isLoading: !data && !error,
        error: error || responseError
    };
};

export const useSdkDownload = (archive_id?: number, archive_type?: string): {isLoading: boolean; error?: string} => {
    const {data, error} = useSWR(archive_id && archive_type ? createKey({archive_id, archive_type}) : null, sdkApi.postSdkDownload, {
        errorRetryCount: 1,
        revalidateOnFocus: false
    });

    return {
        isLoading: !data && !error,
        error
    };
};
